module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-5be1347c.eot";